import { useCallback } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";

function MessageEditButton({ messageId }) {
  const navigate = useNavigate();
  const clickHandler = useCallback(() => {
    navigate(`/workshop/msubm/form/${messageId}`);
  }, [navigate, messageId]);
  return <Button size="small" icon={<EditOutlined />} onClick={clickHandler} />;
}

export default MessageEditButton;
